import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActiveFilterChip, FilterChipId } from './filterSections';
import { ReactComponent as CloseIcon } from './assets/close.svg';
import styles from './SocialGraphPOC.module.scss';

// Active-filter chip row under the metric chips on the canvas (Figma 1229-52 /
// 1229-57, layout 1230-1014). "Clear all filters" is the first item so it never
// moves; each chip is one filter type and its × resets that whole type. Two or
// more values collapse to "first +N" with the full list in the title tooltip.
export const FilterChips: React.FC<{
  chips: ActiveFilterChip[];
  onRemove: (id: FilterChipId) => void;
  onClearAll: () => void;
}> = ({ chips, onRemove, onClearAll }) => {
  const { t } = useTranslation();
  if (chips.length === 0) return null;
  return (
    <div
      className={styles.filterChipsRow}
      role="group"
      aria-label={t('Active filters')}
    >
      <button
        type="button"
        className={styles.filterChipsClearAll}
        onClick={onClearAll}
      >
        {t('Clear all filters')}
      </button>
      {chips.map((chip) => {
        const [first, ...rest] = chip.values;
        const value = rest.length > 0 ? `${first} +${rest.length}` : first;
        const fullLabel = chip.group
          ? `${chip.group} ${chip.values.join(', ')}`
          : chip.values.join(', ');
        return (
          <span
            key={chip.key}
            className={styles.filterChip}
            title={rest.length > 0 ? fullLabel : undefined}
          >
            {chip.group && <span>{chip.group}:</span>}
            <span>{value}</span>
            <button
              type="button"
              className={styles.filterChipRemove}
              onClick={() => onRemove(chip.id)}
              aria-label={t('Remove filter: {{filter}}', { filter: fullLabel })}
            >
              <CloseIcon aria-hidden="true" />
            </button>
          </span>
        );
      })}
    </div>
  );
};
